import { defineMessages } from 'react-intl';

export default defineMessages({
  edit: 'Edytuj',
  restore: 'Przywróć kartotekę',
  remove: 'Usuń kartotekę',
  download: 'Pobierz dane',
});
